import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import ReactDatePicker from 'react-datepicker';
import { InputGroup, Input, InputRightElement, Image, Box } from '@chakra-ui/react';
import { calendarInput } from '../../assets/new-images/icons';

const DatePicker = ({
  control,
  name,
  defaultValue,
  selectedDate,
  minDate,
  onChange,
  dateFormat,
  dateFormatCalendar,
  selectsStart,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => (
          <InputGroup display='grid' isolation='unset'>
            <ReactDatePicker
              name={name}
              selected={selectedDate}
              locale='pt-BR'
              showPopperArrow={false}
              onChange={(date) => {
                field.onChange(date);
                onChange(date);
              }}
              placeholderText='Selecione'
              autoComplete='off'
              disabled={disabled}
              {...(dateFormatCalendar
                ? {
                    dateFormatCalendar: 'MMMM | yyyy',
                    dateFormat: 'P',
                  }
                : {
                    dateFormat: dateFormat || 'MMM/yyyy',
                  })}
              minDate={minDate}
              {...(selectsStart && {
                selectsStart,
              })}
              open={isOpen}
              onInputClick={() => setIsOpen(true)}
              onClickOutside={() => setIsOpen(false)}
              customInput={
                <Input
                  value={field?.value}
                  aria-label='Selecione'
                  autoComplete='off'
                  _autofill={{
                    bg: '#F5F5FB !important',
                    WebkitBoxShadow: '0 0 0px 1000px #F5F5FB inset',
                    WebkitTextFillColor: '#000000',
                    transition: 'background-color 5000s ease-in-out 0s',
                  }}
                  type='text'
                  _focusVisible={{
                    borderColor: 'inherit',
                  }}
                  _disabled={{
                    bg: '#E5E5E5',
                    borderColor: '#DCCFEC',
                    cursor: 'not-allowed',
                  }}
                  readOnly
                  onClick={() => setIsOpen(true)}
                />
              }
            />
            <InputRightElement
              pointerEvents='none'
              display={'flex'}
              alignItems='center'
              h='100%'
              cursor='pointer'
            >
              <Image src={calendarInput} alt='calendar' mr='10px' height='23px' />
            </InputRightElement>
          </InputGroup>
        )}
      />
    </Box>
  );
};

export default DatePicker;